import React, { useCallback, useMemo, useState } from 'react';
import { favoriteBetsStore } from '../../store/favoriteBetsStore';
import { parseNumberByPrecision, useTranslation, useUserInfoStore } from '@pascal/pascal-core';
import { mathConfig, mathJS } from '../../helpers/mathFormat';

export const FavoriteBetsRows = ({ name, id, favouriteBets, handleDoFavoriteBet }) => {
  const [editName, setEditNAme] = useState(false);
  const [favoriteBetName, setFavoriteBetName] = useState('');

  const t = useTranslation();
  const { currencySymbolOrCode } = useUserInfoStore();

  const handleEditFunc = useCallback(() => {
    favoriteBetName && favoriteBetsStore.editFavoriteBet({ name: favoriteBetName, favouriteBetId: id });
    setEditNAme(false);
  }, [favoriteBetName]);

  const handleDeleteRow = useCallback(() => {
    favoriteBetsStore.deleteFavoriteBet(id);
    setEditNAme(false);
  }, [id]);

  const countTotalBetAmount = useMemo(() => {
    return (
      favouriteBets &&
      Object.values(favouriteBets).reduce((acc, curr) => {
        if (curr.includedBets) {
          curr.includedBets.forEach((item) => (acc = parseNumberByPrecision(1, +mathJS.format(+(acc + item.amount), mathConfig))));
        } else {
          acc = parseNumberByPrecision(1, +mathJS.format(+(acc + curr.bet?.amount), mathConfig));
        }
        return acc;
      }, 0)
    );
  }, [favouriteBets]);

  return (
    <div className={`r-a-p-row ${editName ? 'editable' : ''}`}>
      <div className='r-a-p-row-l' onClick={() => handleDoFavoriteBet(favouriteBets, countTotalBetAmount, editName)}>
        <div className='r-a-p-row-num'> </div>
      </div>
      <div className='r-a-p-row-c' onClick={() => handleDoFavoriteBet(favouriteBets, countTotalBetAmount, editName)}>
        <div className='r-a-p-input-wrapper'>
          <div className='r-a-p-input-inner'>
            <input
              className='r-a-p-input'
              placeholder={name}
              type='text'
              maxLength={20}
              value={favoriteBetName}
              onChange={(e) => setFavoriteBetName(e.target.value)}
            />
          </div>
        </div>
        <div className='r-a-p-row-info'>
          <p title={t(name)}>{t(name)}</p>
        </div>
        <div className='r-a-p-row-info'>
          <span>{`${countTotalBetAmount} ${currencySymbolOrCode}`}</span>
        </div>
      </div>
      <div className='r-a-p-row-r'>
        <div className='r-a-p-action check' onClick={handleEditFunc}>
          <div className='r-a-p-action-inner'>
            <i className='icon-checked' />
          </div>
        </div>
        <div className='r-a-p-action remove' onClick={handleDeleteRow}>
          <div className='r-a-p-action-inner'>
            <i className='icon-bin' />
          </div>
        </div>
        <div className='r-a-p-action edit' onClick={() => setEditNAme(true)}>
          <div className='r-a-p-action-inner'>
            <i className='icon-edit' />
          </div>
        </div>
      </div>
    </div>
  );
};
